import React from "react";
import { Badge, BadgeType, BadgeTypeName, BadgeTypeColor } from "../../../types/badge";
import {
  DropdownAction,
  DefaultColumnBuilder as builder,
} from "../../components/ColumnBuilder";
import { Table, Tag } from "antd";

export interface BadgeTableProps {
  loading?: boolean;
  records: Badge[];
  onDelete?: (id: number) => void;
}

export const BadgeTable = (props: BadgeTableProps) => {
  const columns = [
    builder.id,
    {
      title: "Type",
      dataIndex: "type",
      render: (type: BadgeType) => (
        <Tag color={BadgeTypeColor[type]}>{BadgeTypeName[type]}</Tag>
      ),
    },
    builder.text("Message", "message"),
    builder.date("Created", "createdAt"),
    builder.dropdown([DropdownAction.DELETE], (id, action) => {
      switch (action) {
        case DropdownAction.DELETE:
          return props.onDelete?.(id);
      }
    }),
  ];

  return (
    <Table
      columns={columns}
      pagination={false}
      scroll={{ x: true }}
      loading={props.loading}
      dataSource={(props.records || []).map((record) => ({
        ...record,
        key: record.id,
      }))}
    />
  );
};
